module.exports = __webpack_public_path__ + "img/pexels-photo-1024311.6d36d83f.jpg";